import _ from 'lodash';

function PlayerSelectModalCtrl($rootScope, $scope, $state, $stateParams, $timeout, toastr, PlanService, UserService, AppSettings, AppContextService) {
  'ngInject';

  /**
   * appContext.type.id, appContext.team.id 가 전달된다.
   */

  var vm = this;
  vm.appContext = AppContextService.context;

  // 선택된 선수
  vm.entryMain = [];
  vm.entryBackup = [];


  $scope.$watch('playerSelectModal.appContext.type.id', function (newVal, oldVal) {
    if (newVal) {
      console.log('type.id', newVal)
      //vm.init();
    }
  });

  $scope.$watch('playerSelectModal.appContext.team.id', function (newVal, oldVal) {
    if (newVal) {
      console.log('team.id', newVal)
      //vm.init();
    }
  });




  vm.copyToEntry = function (player) {
    // TODO : id로 체크
    if (_.find(vm.entryMain, player)) {
      toastr.error('이미 Entry에 등록되어 있습니다.');
      return;
    }
    if (_.find(vm.entryBackup, player)) {
      toastr.error('이미 Entry에 등록되어 있습니다.');
      return;
    }

    if (vm.entryType === 'main') {
      vm.entryMain.push(player);
    }
    if (vm.entryType === 'backup') {
      vm.entryBackup.push(player);
    }
  }

  vm.cancel = function () {
  }

  // // 기존선수를 삭제(OUT)한 후, 추가(IN)한다.
  // var setEntry = function (is_oppo, oldVal, newVal) {
  //   var data = {
  //     login_id: vm.appContext.user.login_id,
  //     uuid: vm.appContext.user.uuid,
  //     game_id: $stateParams.game_id,
  //     user_id: _.map(oldVal, 'user_id').join(),
  //     status: 'OUT',
  //     is_oppo: is_oppo
  //   };

  //   PlanService.setEntry(data)
  //     .then(function (res) {
  //       data.user_id = _.map(newVal, 'user_id').join();
  //       data.status = 'IN'
  //       return PlanService.setEntry(data);
  //     })
  //     .catch(function (error) {
  //       console.log("An error occured : " + error);
  //     })


  // }






  vm.save = function () {
    // api response와 일치시키기 위하여 position_name을 추가
    console.log(vm)
    // var players = vm.entryMain;
    // players.forEach(function (player) {
    //   player['position_name'] = player.position;
    // })
    // players = vm.entryBackup;
    // players.forEach(function (player) {
    //   player['position_name'] = player.position;
    // })
    // vm.appContext.players[vm.appContext.type.id][vm.appContext.team.id].entryMain = _.cloneDeep(vm.entryMain)
    // vm.appContext.players[vm.appContext.type.id][vm.appContext.team.id].entryBackup = _.cloneDeep(vm.entryBackup)


    console.log('vm.appContext.type:', vm.appContext.type); 
    console.log('vm.appContext.team:', vm.appContext.team); 
    console.log('old', vm.appContext.players[vm.appContext.type.id][vm.appContext.team.id].entryMain); 
    console.log('new', vm.entryMain); 

    // console.log('old', vm.appContext.players[])


    return;

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      game_id: $stateParams.game_id,
      user_id: _.map(oldVal, 'user_id').join(),
      status: 'OUT',
      is_oppo: is_oppo
    };

    PlanService.setEntry(data)
      .then(function (res) {
        data.user_id = _.map(newVal, 'user_id').join();
        data.status = 'IN'
        return PlanService.setEntry(data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })

  }

  vm.remove = function (players, player) {
    _.remove(players, player);
  }


  UserService.getCountries().then(function (res) {
    vm.continents = res.data.list;
  });


  // 대륙 변경
  $scope.$watch('playerSelectModal.continent', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getCountries({ parent_id: newVal.id }).then(function (res) {
        vm.countries = res.data.list;
      });
    }
  });

  var country_id;
  // 국가 변경
  $scope.$watch('playerSelectModal.country', function (newVal, oldVal) {
    if (newVal) {
      // 초기 팀 목록 불러오기
      country_id = newVal.id;
      UserService.getTeams({ country_id: newVal.id }).then(function (res) {
        vm.teams1 = res.data.list;
      });
    }
  });

  // 팀 1단계 변경
  $scope.$watch('playerSelectModal.selectedTeam1', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getTeams({
        country_id: country_id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.teams2 = res.data.list
      });
    } else {
    }
  });

  // 팀 2단계 변경
  $scope.$watch('playerSelectModal.selectedTeam2', function (newVal, oldVal) {
    vm.selectedTeam3 = null;
    vm.selectedTeam4 = null;
    if (newVal && !newVal.is_last) {
      UserService.getTeams({
        country_id: country_id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.teams3 = res.data.list;
      });
    } else {
      vm.teams3 = null;
    }
  });

  // 팀 3단계 변경
  $scope.$watch('playerSelectModal.selectedTeam3', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getTeams({
        country_id: country_id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.teams4 = res.data.list;
      });
    } else {
      vm.teams4 = null;
    }
  });

  // 팀 4단계 변경
  $scope.$watch('playerSelectModal.selectedTeam4', function (newVal, oldVal) {
    if (newVal) {
      let params = {
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        limit: 100,
        page: 1,
        team_id: newVal.id,
        step2: 'Y'
      };
      vm.appContext.oppoTeam_id = newVal.id;
      UserService.getUserList(params).then(function (res) {
        vm.playersAll = res.data.list;
      });
    }
  });

}

export default {
  name: 'PlayerSelectModalCtrl',
  fn: PlayerSelectModalCtrl
};
